export default __webpack_public_path__ + "static/media/Suhada.927b7e87.png";